import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import {Button} from 'reactstrap';
import { ROUTE_CLIENT_ORDER_CREATE } from '../../../../config/routes';
import { history, store } from '../../../../store/store';
import { ACL } from '../../../../config/constants';
import { hideNotification } from '../../../../store/actions/notification';

function CreateOrder() {
  if (! ACL.CLIENT.ORDERS.CREATE.hasAccess()) {
    return null;
  }

  return (
    <Fragment>
      <Button
        className="btn-warning"
        color="primary"
        onClick={() => {
         store.dispatch(hideNotification());
         history.push(ROUTE_CLIENT_ORDER_CREATE);
        }}
        size="sm"
      >
        <FormattedMessage
          id="components.pages.orderManagement.actionButtons.create_order"/>
      </Button>
    </Fragment>
  )
}

export { CreateOrder };
